import { request } from "$/lib/api"
import { Route, ServiceBookingLeadTime, populateRoute } from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

async function fetchLeadTime(storeId: string): Promise<ServiceBookingLeadTime> {
  return await request<ServiceBookingLeadTime>({
    url: populateRoute(Route.BOOKING_RULES__GET_LEAD_TIME, storeId),
    method: "GET",
  })
}

async function setLeadTime(storeId: string, data: ServiceBookingLeadTime) {
  return await request<void>({
    url: populateRoute(Route.BOOKING_RULES__SET_LEAD_TIME, storeId),
    method: "PUT",
    data,
  })
}

export function useLeadTimeMutations(storeId: string) {
  const queryClient = useQueryClient()

  const invalidateQueries = async () => {
    await queryClient.invalidateQueries(leadTimeQueries.all(storeId))
  }

  const setMutation = useMutation({
    mutationFn: (data: ServiceBookingLeadTime) => setLeadTime(storeId, data),
    onSettled: invalidateQueries,
  })

  return { setMutation }
}

const leadTimeQueries = {
  all: (storeId: string) =>
    queryOptions({
      queryKey: ["lead-time", storeId],
      queryFn: () => fetchLeadTime(storeId),
    }),
}

export default leadTimeQueries
